import React, { useState } from "react";
import Layout from "../components/Layout";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";

const REF_STORAGE_KEY = "cb_ref_code";

function readStoredRef() {
  try {
    const raw = localStorage.getItem(REF_STORAGE_KEY);
    if (!raw) return "";
    const { code, exp } = JSON.parse(raw);
    if (!code || !exp || Date.now() > exp) return "";
    return code;
  } catch (_) { return ""; }
}

export default function Register() {
  const { register } = useAuth();
  const [params] = useSearchParams();
  const [form, setForm] = useState({
    email: "",
    username: "",
    password: "",
    referral_code: (params.get("ref") || readStoredRef() || "").toUpperCase(),
  });
  const [accepted, setAccepted] = useState(false);
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (!accepted) {
      toast.error("You must accept the Terms & Privacy Policy");
      return;
    }
    setLoading(true);
    try {
      await register(form);
      if (form.referral_code) {
        toast.success("Welcome bonus credited! +100 BC");
        try { localStorage.removeItem(REF_STORAGE_KEY); } catch (_) { /* noop */ }
      } else {
        toast.success("Account created!");
      }
      nav("/game");
    } catch (err) {
      toast.error(err.message || "Registration failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout hideNav>
      <div className="px-5 py-10 max-w-sm mx-auto cb-rise">
        <h1
          className="font-pixel text-[18px] text-glow-green mb-6 text-center"
          data-testid="register-title"
        >
          ◼ NEW PLAYER
        </h1>
        <form onSubmit={submit} className="flex flex-col gap-4">
          <div>
            <label className="font-pixel text-[9px] text-[#8b95a9] mb-2 block">
              USERNAME
            </label>
            <input
              required
              minLength={3}
              maxLength={24}
              data-testid="register-username-input"
              className="cb-input"
              value={form.username}
              onChange={(e) => setForm({ ...form, username: e.target.value })}
            />
          </div>
          <div>
            <label className="font-pixel text-[9px] text-[#8b95a9] mb-2 block">
              EMAIL
            </label>
            <input
              type="email"
              required
              data-testid="register-email-input"
              className="cb-input"
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
            />
          </div>
          <div>
            <label className="font-pixel text-[9px] text-[#8b95a9] mb-2 block">
              PASSWORD
            </label>
            <input
              type="password"
              required
              minLength={6}
              data-testid="register-password-input"
              className="cb-input"
              value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })}
            />
          </div>
          <div>
            <label className="font-pixel text-[9px] text-[#8b95a9] mb-2 block">
              REFERRAL CODE (OPTIONAL)
            </label>
            <input
              data-testid="register-referral-input"
              className="cb-input"
              value={form.referral_code}
              onChange={(e) =>
                setForm({ ...form, referral_code: e.target.value.toUpperCase() })
              }
            />
          </div>
          <label className="flex items-start gap-2 text-[11px] text-[#8b95a9] leading-snug cursor-pointer select-none">
            <input
              type="checkbox"
              checked={accepted}
              onChange={(e) => setAccepted(e.target.checked)}
              data-testid="register-accept-terms"
              className="mt-[3px] accent-[#2ecc71] flex-shrink-0"
            />
            <span>
              Acepto los{" "}
              <Link to="/terms" target="_blank" className="text-[#2ecc71]">Términos</Link>{" "}
              y la{" "}
              <Link to="/privacy" target="_blank" className="text-[#2ecc71]">Política de Privacidad</Link>.
            </span>
          </label>
          <button
            type="submit"
            disabled={loading || !accepted}
            data-testid="register-submit-btn"
            className="cb-neon-btn mt-2"
          >
            {loading ? "..." : "Create Account"}
          </button>
        </form>
        <div className="mt-6 text-center text-xs text-[#8b95a9]">
          Already have an account?{" "}
          <Link
            to="/login"
            className="text-[#2ecc71]"
            data-testid="go-login-link"
          >
            Sign in
          </Link>
        </div>
      </div>
    </Layout>
  );
}
